import React, { Component } from "react";

export class AssessSearch extends Component {
  constructor(props) {
    super(props);

    let currentAdminRole = localStorage.getItem("currentAdminRole");

    let initialFields = [
      {
        type: "select",
        name: "school_id",
        label: "School Name",
        placeholder: "Select",
        onChange: (data) => this.handleSchoolChange(data),
        options: [],
      },
      {
        type: "select",
        name: "class_id",
        label: "Class Name",
        placeholder: "Select",
        disabled: currentAdminRole === "SCHOOL_ADMIN" || currentAdminRole === "SCHOOL_COORDINATOR" ? false : true,
        onChange: (data) => this.handleClassChange(data),
        options: [],
      },
      {
        type: "select",
        name: "section_id",
        label: "Section",
        placeholder: "Select",
        disabled: true,
        options: [],
      },
      {
        type: "select",
        name: "reports_available",
        label: "Reports Available",
        placeholder: "Select",
        options: [
          { label: "Half Yearly", key: "Half Yearly" },
          { label: "Yearly", key: "Yearly" },
        ]
      }
    ];

    if (currentAdminRole === "SCHOOL_ADMIN" || currentAdminRole === "SCHOOL_COORDINATOR") {
      initialFields = initialFields.filter(f => f.name !== 'school_id');
    }

    this.state = {
      classesData: [],
      fields: initialFields,
    };
  }

  handleSchoolChange(data) {
    let value = data;
    if (Array.isArray(data) && data.length > 0) {
      value = data[0].value || data[0].key || data[0].id || data[0];
    } else if (data && typeof data === 'object') {
      value = data.target ? data.target.value : (data.value || data.key || data.id || data);
    }

    let newFields = [...this.state.fields];
    let classField = newFields.find(f => f.name === 'class_id');
    let sectionField = newFields.find(f => f.name === 'section_id');

    if (value && String(value).trim().length > 0) {
      if (this.props.api) {
        this.props.api.apiGetClassBySchool({ school_id: value })
          .then((res) => {
            let classes = [];
            if (res && res.data && Array.isArray(res.data) && res.data[0] && res.data[0].records) {
              classes = res.data[0].records;
            } else if (res && res.data && res.data.records) {
              classes = res.data.records;
            } else if (res && Array.isArray(res.data)) {
              classes = res.data;
            } else if (Array.isArray(res)) {
              classes = res;
            }

            classField.disabled = false;
            classField.options = classes.map(c => ({
              label: c.curriculum_name || c.class_id,
              key: c.class_id
            }));
            sectionField.disabled = true;
            sectionField.options = [];

            // clear selected values for class and section when school changes
            classField.value = "";
            sectionField.value = "";

            this.setState({ fields: newFields, classesData: classes });
          })
          .catch(err => console.error(err));
      }
    } else {
      classField.disabled = true;
      classField.options = [];
      sectionField.disabled = true;
      sectionField.options = [];

      classField.value = "";
      sectionField.value = "";

      this.setState({ fields: newFields, classesData: [] });
    }
  }

  handleClassChange(data) {
    let value = data;
    if (Array.isArray(data) && data.length > 0) {
      value = data[0].value || data[0].key || data[0].id || data[0];
    } else if (data && typeof data === 'object') {
      value = data.target ? data.target.value : (data.value || data.key || data.id || data);
    }
    let newFields = [...this.state.fields];
    let sectionField = newFields.find(f => f.name === 'section_id');
    if (value && String(value).trim().length > 0) {
      sectionField.disabled = false;
      let selectedClass = this.state.classesData.find(c => c.class_id === value);
      if (selectedClass && selectedClass.section) {
        sectionField.options = selectedClass.section.map(s => ({
          label: s.name,
          key: s.section_id
        }));
      } else {
        sectionField.options = [];
      }

      sectionField.value = "";

    } else {
      sectionField.disabled = true;
      sectionField.options = [];

      sectionField.value = "";
    }
    this.setState({ fields: newFields });
  }

  componentDidMount() {
    if (this.props.api) {
      let currentAdminRole = localStorage.getItem("currentAdminRole");

      if (currentAdminRole === "SCHOOL_ADMIN" || currentAdminRole === "SCHOOL_COORDINATOR") {
        let school_id = currentAdminRole === "SCHOOL_ADMIN" ? localStorage.getItem("school_admin_id") : localStorage.getItem("school_id");
        school_id = school_id || "";
        this.props.api.apiGetClassBySchool({ school_id: school_id })
          .then((res) => {
            let classes = [];
            if (res && res.data && Array.isArray(res.data) && res.data[0] && res.data[0].records) {
              classes = res.data[0].records;
            } else if (res && res.data && res.data.records) {
              classes = res.data.records;
            } else if (res && Array.isArray(res.data)) {
              classes = res.data;
            } else if (Array.isArray(res)) {
              classes = res;
            }

            let newFields = [...this.state.fields];
            let classField = newFields.find(f => f.name === 'class_id');
            if (classField) {
              classField.options = classes.map(c => ({
                label: c.curriculum_name || c.class_id,
                key: c.class_id
              }));
            }

            this.setState({ fields: newFields, classesData: classes });
          })
          .catch(err => console.error(err));
      } else {
        this.props.api.apiGetSchoolList()
          .then((res) => {
            let schools = [];
            if (res && res.data && Array.isArray(res.data) && res.data[0] && res.data[0].records) {
              schools = res.data[0].records;
            } else if (res && res.data && res.data.records) {
              schools = res.data.records;
            } else if (res && Array.isArray(res.data)) {
              schools = res.data;
            } else if (Array.isArray(res)) {
              schools = res;
            }

            let newFields = [...this.state.fields];
            let schoolField = newFields.find(f => f.name === 'school_id');
            if (schoolField) {
              schoolField.options = schools.map(s => ({ label: s.school_name, key: s.school_id }));
            }
            this.setState({ fields: newFields });
          })
          .catch(err => console.error(err));
      }
    }
  }

  onSearch() {
    if (this.refs.form && this.refs.form.form.current) {
      let data = this.refs.form.form.current.getData();
      this.props.onSearch && this.props.onSearch(data);
    }
  }

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map(field => ({ ...field, value: '' }))
    });

    if (this.refs.form && this.refs.form.form.current) {
      this.refs.form.form.current.reset();
    }

    const clearedData = {};
    this.state.fields.forEach(f => {
      clearedData[f.name] = "";
    });

    this.props.onSearch && this.props.onSearch(clearedData);
  };

  render() {
    let { fields } = this.state;
    return (
      <div className="card bg-white p-3 mb-4 pb-4">
        <AppForm className="row filter-row align-items-end" ref="form">
          {fields.map((field, i) => {
            let colClass = "col-md-2";
            if (fields.length === 3) {
              if (field.name === 'class_id' || field.name === 'section_id') {
                colClass = "col-md-3";
              } else if (field.name === 'reports_available') {
                colClass = "col-md-4";
              }
            } else {
              if (field.name === 'school_id' || field.name === 'reports_available') {
                colClass = "col-md-3";
              }
            }
            return (
              <div className={`${colClass} mb-2 position-relative`} key={i}>
                <AppInput {...field}></AppInput>
                {field.name === 'reports_available' && (
                  <div className="position-absolute w-100 text-end" style={{ bottom: '-22px', right: '12px' }}>
                    <span
                      className="clear-all mb-0"
                      style={{ cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: '#16223e', textDecoration: 'underline' }}
                      onClick={() => this.clearTextData()}
                    >
                      Clear All
                    </span>
                  </div>
                )}
              </div>
            );
          })}
          <div className="col-md-2 mb-2">
            <button
              type="button"
              className="btn w-100"
              style={{ backgroundColor: '#f39c12', color: 'white', fontWeight: 'bold' }}
              onClick={() => this.onSearch()}
            >
              Search
            </button>
          </div>
        </AppForm>
      </div>
    );
  }
}

export default connect(AssessSearch);
